
import React, { createContext, useState, useEffect, useRef, useCallback } from 'react';
import { firestore, storage, database } from './firebase';
import { collection, getDocs, query, setDoc, orderBy, limit, onSnapshot, getDoc, doc, updateDoc, getFirestore, increment, where, deleteDoc, runTransaction } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { ref as databaseRef, update, set, get, onDisconnect, ref, getDatabase, onValue, off } from 'firebase/database';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { StreamVideoClient } from '@stream-io/video-react-sdk';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const setUser = (userData) => {
    setCurrentUser(userData);
  };

  const guestUser = {
    userId: "guest",  // A fixed value that won't conflict with real user IDs
    username: "Guest",
    email: null,
    // Add other properties your app relies on
  };
  
  const functions = getFunctions();

  const [assetsSummary, setAssetsSummary] = useState(null);

  useEffect(() => {
    const fetchSummaryAssets = async () => {
      try {
        const db = getFirestore();
        const summaryDocRef = doc(db, 'assetsSummary', 'main');
        const summaryDocSnap = await getDoc(summaryDocRef);
  
        if (summaryDocSnap.exists()) {
          const summaryData = summaryDocSnap.data();
          setAssetsSummary(summaryData.assets || []);
  
        } else {
          console.warn('Summary document does not exist.');
          setAssetsSummary([]);
        }
      } catch (error) {
        console.error('Error fetching summary assets:', error);
      } finally {
   
      }
    };
  
    fetchSummaryAssets();
  }, []);


  const [dataFeaturedMusic, setDataFeaturedMusic] = useState([]);
  const [featuredSongs, setFeaturedSongs] = useState([]);
  const [newReleases, setNewReleases] = useState([]);

  const [groupedByGenres, setGroupedByGenres] = useState({});
  const [lastGenreDocs, setLastGenreDocs] = useState({});
  const [dataFeaturedVideos, setDataFeaturedVideos] = useState([]);
  const [newVideoReleases, setNewVideoReleases] = useState([]); 

  const auth = getAuth();

  const [stateCountsSKN, setStateCountsSKN] = useState({});
  const [recentData, setRecentData] = useState({});
  const stateListeners = useRef({});
  const [showNewMessageScreen, setShowNewMessageScreen] = useState(false);

  const [selectedProfile, setSelectedProfile] = useState(null);

  const [selectedUserIdShare, setSelectedUserIdShare] = useState(null);

  const [showSharePostPopup, setShowSharePostPopup] = useState(false);

  const [showShareDATPopup, setShowShareDATPopup] = useState(false);

  const [showShareDATPopupProfile, setShowShareDATPopupProfile] = useState(false);

  const [showCreditSharePopup, setShowCreditSharePopup] = useState(false);

  const [showCreditSharePopupProfile, setShowCreditSharePopupProfile] = useState(false);

  const [showSuccessAlertShareCredits, setShowSuccessAlertShareCredits] = useState(false);

  const [currentlySharingCredits, setCurrentlySharingCredits] = useState(false);



  const [postToShare, setPostToShare] = useState(null);

  const [userId2, setUserId2] = useState();
  const db = getFirestore();

  const [notifications, setNotifications] = useState([]);

  const consolidateNotifications = (notifications) => {
    const groupedNotifications = {};
  
    notifications.forEach(notification => {
      let key;
      if (notification.postId && notification.commentId) {
        key = `comment-${notification.postId}-${notification.commentId}`;
      } else if (notification.postId && notification.replyId) {
        key = `reply-${notification.postId}-${notification.replyId}`;
      } else {
        key = `unique-${notification.id}`; // Unique key for non-groupable notifications
      }
  
      if (!groupedNotifications[key]) {
        groupedNotifications[key] = [notification];
      } else {
        groupedNotifications[key].push(notification);
      }
    });
  
    return Object.values(groupedNotifications).map(group => {
      if (group.length > 1) {
        // Create a new type for consolidated notifications
        return {
          ...group.find(n => n.type === 'reply') || group[0], // Prefer 'reply' as base notification
          type: 'consolidatedReplyTag', // New type for consolidated notifications
          originalNotifications: group // Store original notifications for reference
        };
      }
      return group[0];
    });
  };


  


  const [isViewingScreenSKN, setIsViewingScreenSKN] = useState(false);

  const [currentlyBuying, setCurrentlyBuying] = useState(false);
  const [showSuccessAlertSKN, setShowSuccessAlertSKN] = useState(false);

  const [likes, setLikes] = useState({});
  const [reposts, setReposts] = useState({});

  const [activeCategory, setActiveCategory] = useState('default');

  const [viewingDefaultAnalytics, setViewingDefaultAnalytics] = useState(false);
  const [viewingDefaultAnalyticsLocal, setViewingDefaultAnalyticsLocal] = useState(true);

  const [viewingTotalSpnsAnalytics, setViewingTotalSpnsAnalytics] = useState(false);
  const [viewingAlbumAnalytics, setViewingAlbumAnalytics] = useState(false);
  const [viewingSingleAnalytics, setViewingSingleAnalytics] = useState(false);
  const [viewingVideosAnalytics, setViewingVideosAnalytics] = useState(false);
  const [viewingVerchAnalytics, setViewingVerchAnalytics] = useState(false);

  const [profileImage, setProfileImage] = useState('');
  const [credits, setCredits] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [posts, setPosts] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [purchasedMedia, setPurchasedMedia] = useState([]);

  const [voiceDropMuted, setVoiceDropMuted] = useState(true);
  const [followers, setFollowers] = useState([]);
  const [following, setFollowing] = useState([]);
  const [numberOfFollowers, setNumberOfFollowers] = useState(0);
const [numberOfFollowing, setNumberOfFollowing] = useState(0);
const [bio, setBio] = useState('');
const [blurb, setBlurb] = useState('');

const [currentAnalyticsImage, setCurrentAnalyticsImage] = useState(require('./assets/AnalyticsBoxes.png'));

const [screenSKNs, setScreenSKNs] = useState([]);

  const [playlistsFresh, setPlaylistsFresh] = useState([]);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const [profileImageUrl, setProfileImageUrl] = useState('');

  const [sharePostActive, setSharePostActive] = useState(false);

  const [shareDATactive, setShareDATactive] = useState(false);

  const [currentlyReleasing, setCurrentlyReleasing] = useState(false);

  const [totalSpns, setTotalSpns] = useState(0);
  const [musicSpns, setMusicSpns] = useState(0);
  const [videoSpns, setVideoSpns] = useState(0);
  const [singlesSales, setSinglesSales] = useState(0);
  const [albumsSales, setAlbumsSales] = useState(0);
  const [videosSales, setVideosSales] = useState(0);

  const [currentEarnings, setCurrentEarnings] = useState(0);
const [totalEarnings, setTotalEarnings] = useState(0);
const [verchSales, setVerchSales] = useState(0);

  const creditsUnsubscribeRef = useRef(null);
  const statsUnsubscribeRef = useRef(null);

  const currentEarningsUnsubscribeRef = useRef(null);
const totalEarningsUnsubscribeRef = useRef(null);
const verchUnsubscribeRef = useRef(null);

  const [creditsIOS, setCreditsIOS] = useState(0);


  const earnedCreditsUnsubscribeRef = useRef(null);


  const [miniPlayer, setMiniPlayer] = useState(null);
  const [miniPlayerVideo, setMiniPlayerVideo] = useState(null);
  const [audio, setAudio] = useState(null);

  const audioRef = useRef(null);
  const videoRef = useRef(null);
  const playbackIntervalRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [isPlaylist, setIsPlaylist] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [videoURL, setVideoURL] = useState(null);

  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const [currentPlaylist, setCurrentPlaylist] = useState([]);
const [currentIndex, setCurrentIndex] = useState(0);
const [isShuffle, setIsShuffle] = useState(false);

const [joiningLive, setJoiningLive] = useState(false);

  const [currentlyLoadingProfile, setCurrentlyLoadingProfile] = useState(false);

const [isUnder400, setIsUnder400] = useState(window.innerWidth < 400 && window.innerWidth > 390);

const [isUnder390, setIsUnder390] = useState(window.innerWidth < 390);

const [is480, setIs480] = useState(window.innerWidth === 480);

const [isUnder480, setIsUnder480] = useState(window.innerWidth < 480);

const [isBetween400And479, setIsBetween400And479] = useState(window.innerWidth >= 400 && window.innerWidth < 479);

const [musicVideos, setMusicVideos] = useState([]);

useEffect(() => {
  const handleResize = () => {
    setIsUnder400(window.innerWidth < 400);
    setIsUnder390(window.innerWidth < 390);
    setIsUnder480(window.innerWidth < 480);
    setIs480(window.innerWidth === 480);
    setIsBetween400And479(window.innerWidth >= 400 && window.innerWidth < 479);
  };

  window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);









  useEffect(() => {
    return () => {
      if (audioRef.current) {
        
        audioRef.current.pause();
        audioRef.current.removeEventListener('abort', handleAbort);
        audioRef.current.removeEventListener('error', handleError);
        audioRef.current.removeEventListener('play', handlePlay);
        audioRef.current.removeEventListener('pause', handlePause);
        audioRef.current.removeEventListener('loadeddata', handleLoadedData);
        audioRef.current.removeEventListener('canplaythrough', handleCanPlayThrough);
      }
      clearInterval(playbackIntervalRef.current);
    };
  }, []);

  const handleAbort = (event) => {
    console.error('Audio load aborted:', event);
    setIsPlaylist(false);
  };

  const handleError = (event) => {
    console.error('Audio load error:', event);
  };

  const handlePlay = () => {
    if (audioRef.current) {
      setIsPlaying(true);
      

      playbackIntervalRef.current = setInterval(() => {
        
      }, 1000);
    }
  };

  const handlePause = () => {
    setIsPlaying(false);
    
    clearInterval(playbackIntervalRef.current);
  };

  const togglePlayPause = useCallback(() => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play().catch((error) => {
          if (error.name === 'NotAllowedError' || error.name === 'NotSupportedError') {
            console.error('Browser prevented audio playback:', error);
          } else {
            console.error('Error playing audio:', error);
          }
        });
      }
    }
  }, [isPlaying]);

  const playVideo = (url) => {
    if (videoRef.current) {
      if (videoRef.current.src !== url) {
        videoRef.current.src = url;
      }
      videoRef.current.play();
      setIsVideoPlaying(true);
    }
  };

  const pauseVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      setIsVideoPlaying(false);
    }
  };

  const toggleVideoPlayPause = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsVideoPlaying(true);
      } else {
        videoRef.current.pause();
        setIsVideoPlaying(false);
      }
    }
  };

  const handleLoadedData = () => {
    if (audioRef.current) {
      

    }
  };

  const handleCanPlayThrough = () => {
    if (audioRef.current) {
      

      audioRef.current.play().catch(error => {
        console.error('Error playing audio in canplaythrough:', error);
      });
    }
  };

  const playSong = async (songURL) => {
    
  
    if (audioRef.current) {
      
      audioRef.current.pause();
      audioRef.current.removeEventListener('abort', handleAbort);
      audioRef.current.removeEventListener('error', handleError);
      audioRef.current.removeEventListener('play', handlePlay);
      audioRef.current.removeEventListener('pause', handlePause);
      audioRef.current.removeEventListener('loadeddata', handleLoadedData);
      audioRef.current.removeEventListener('canplaythrough', handleCanPlayThrough);
      clearInterval(playbackIntervalRef.current);
    }
  
    
    try {
      const response = await fetch(songURL, { method: 'HEAD' });
  
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
  
      
      
      
      
  
      // Ensure that the content type is something playable
      if (!response.headers.get('Content-Type').startsWith('audio/')) {
        throw new Error('Invalid Content-Type for audio');
      }
    } catch (error) {
      console.error('Network error fetching audio URL:', error);
      return;
    }
  
    
    const newAudio = new Audio(songURL);
    
  
    audioRef.current = newAudio;
  
    newAudio.volume = 1.0;
    newAudio.muted = false;
  
    
    newAudio.addEventListener('abort', handleAbort);
    newAudio.addEventListener('error', handleError);
    newAudio.addEventListener('play', handlePlay);
    newAudio.addEventListener('pause', handlePause);
    newAudio.addEventListener('loadeddata', handleLoadedData);
    newAudio.addEventListener('canplaythrough', handleCanPlayThrough);
  
    
    newAudio.load(); // Explicitly load the audio
  
    
    newAudio.play()
      .then(() => {
        
      })
      .catch((error) => {
        console.error('Audio play promise rejected:', error);
        if (error.name === 'NotAllowedError' || error.name === 'NotSupportedError') {
          console.error('Browser prevented audio playback:', error);
        } else {
          console.error('Error playing audio:', error);
        }
      });
  };
  
  



  const handleCloseClick = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      setMiniPlayer(null);
      setIsPlaying(false);
      setIsPlaylist(false);
    }
    if (videoRef.current) {
      videoRef.current.pause();
      setMiniPlayerVideo(null);
      setIsVideoPlaying(false);
      setIsPlaylist(false);
    }
  };

  const streamContentWEB = httpsCallable(functions, 'streamSummaryContentIOSEdition');


  
  const playPlaylistSequentially = useCallback((playlist) => {
    
    setIsPlaylist(true);
    setCurrentPlaylist(playlist);
    setCurrentIndex(0);
    setIsShuffle(false);
    if (playlist.length > 0) {
      playSong(playlist[0].SongURL);
      setMiniPlayer(playlist[0]);
    }
  }, [playSong]);
  
  const playPlaylistShuffled = useCallback((playlist) => {
    const shuffledPlaylist = [...playlist].sort(() => Math.random() - 0.5);
    setIsPlaylist(true);
    setCurrentPlaylist(shuffledPlaylist);
    setCurrentIndex(0);
    setIsShuffle(true);
    if (shuffledPlaylist.length > 0) {
      playSong(shuffledPlaylist[0].songURL);
      setMiniPlayer(shuffledPlaylist[0]);
    }
  }, [playSong]);
  
  
  useEffect(() => {
    const handleEnded = () => {
      playNextSong();
    };
  
    if (audioRef.current) {
      audioRef.current.addEventListener('ended', handleEnded);
    }
  
    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('ended', handleEnded);
      }
    };
  }, [playNextSong]);


  useEffect(() => {
    if (miniPlayerVideo) {
      playVideo(miniPlayerVideo.VideoURL);
    }
  }, [miniPlayerVideo]);




  const [creditsRaw, setCreditsRaw] = useState('');
  const [creditsCur, setCreditsCur] = useState('');


  const [creditsEarned, setCreditsEarned] = useState('');
  const [creditsPurchased, setCreditsPurchased] = useState('');


  useEffect(() => {
    const auth = getAuth();
  
    // Subscribe to auth state changes
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsLoggedIn(true);

  
        const uid = user.uid;
        // References to the string-based database paths
        const currentCreditsRef = ref(
          database,
          `users/${uid}/summary/currentCreditsStrings`
        );
        const earnedCreditsRef = ref(
          database,
          `users/${uid}/summary/earnedCreditsStrings`
        );
  
        // Helper to safely parse totalCredits from a snapshot
        const safeTotal = (snap) => {
          const data = snap.val() || {};
          const str = data.totalCredits ?? '0.00';
          const num = parseFloat(str);
          return isNaN(num) ? 0 : num;
        };
  
        // Listen for currentCredits first
        creditsUnsubscribeRef.current = onValue(
          currentCreditsRef,
          (curSnap) => {
            const cur = safeTotal(curSnap);
  
            // Teardown any previous earned listener
            earnedCreditsUnsubscribeRef.current?.();
  
            // Now listen for earnedCredits
  earnedCreditsUnsubscribeRef.current = onValue(
    earnedCreditsRef,
    (earnSnap) => {
      const earn = safeTotal(earnSnap);
      const total = cur + earn;
      const display =
      total === 0
        ? 'ADD'
        : total < 1
          ? '0'
          : total >= 10000
            ? `${Math.floor(total / 1000)}k`
            : Math.round(total);
    setCreditsIOS(display);
      setCreditsRaw(total);
      setCreditsEarned(earn);
      setCreditsPurchased(cur);
    },
    (error) =>
      console.error('[EarnedCreditsListener] Error:', error)
  );
          },
          (error) => console.error('[CurrentCreditsListener] Error:', error)
        );
  
        // Subscribe to stats from Realtime Database
        const userStatsRef = ref(database, `users/${uid}/stats`);
        statsUnsubscribeRef.current = onValue(
          userStatsRef,
          (snapshot) => {
            if (snapshot.exists()) {
              const stats = snapshot.val();
              setTotalSpns(stats.totalSpns || 0);
              setMusicSpns(stats.musicSpns || 0);
              setVideoSpns(stats.videoSpns || 0);
              setSinglesSales(stats.sales?.singles || 0);
              setAlbumsSales(stats.sales?.albums || 0);
              setVideosSales(stats.sales?.videos || 0);
            }
          },
          (error) => console.error('[StatsListener] Error:', error)
        );
  
        // Subscribe to currentEarnings
        const userCurrentEarningsRef = ref(
          database,
          `users/${uid}/currentEarnings`
        );
        currentEarningsUnsubscribeRef.current = onValue(
          userCurrentEarningsRef,
          (snapshot) => {
            if (snapshot.exists()) {
              setCurrentEarnings(snapshot.val());
            }
          },
          (error) => console.error('[CurrentEarningsListener] Error:', error)
        );
  
        // Subscribe to totalEarnings
        const userTotalEarningsRef = ref(
          database,
          `users/${uid}/totalEarnings`
        );
        totalEarningsUnsubscribeRef.current = onValue(
          userTotalEarningsRef,
          (snapshot) => {
            if (snapshot.exists()) {
              setTotalEarnings(snapshot.val());
            }
          },
          (error) => console.error('[TotalEarningsListener] Error:', error)
        );
  
        // Subscribe to verch
        const userVerchRef = ref(database, `users/${uid}/verch`);
        verchUnsubscribeRef.current = onValue(
          userVerchRef,
          (snapshot) => {
            if (snapshot.exists()) {
              setVerchSales(snapshot.val());
            }
          },
          (error) => console.error('[VerchListener] Error:', error)
        );
      } else {
        setIsLoggedIn(false);
        creditsUnsubscribeRef.current?.();
        earnedCreditsUnsubscribeRef.current?.();
        statsUnsubscribeRef.current?.();
        currentEarningsUnsubscribeRef.current?.();
        totalEarningsUnsubscribeRef.current?.();
        verchUnsubscribeRef.current?.();
      }
    });
  
    // Cleanup on unmount
    return () => {
      unsubscribeAuth();
      creditsUnsubscribeRef.current?.();
      earnedCreditsUnsubscribeRef.current?.();
      statsUnsubscribeRef.current?.();
      currentEarningsUnsubscribeRef.current?.();
      totalEarningsUnsubscribeRef.current?.();
      verchUnsubscribeRef.current?.();
    };
  }, []);




  const cleanseId = (id) => {
    return id.replace(/\D/g, ''); // This regex removes all non-digit characters
};

const removeContent = async (contentId, isVideo = false) => {
  setLoading(true);
  try {
    if (isVideo) {
      // VIDEOS: only in musicVideoSummaries
      const mvsSnap = await getDocs(collection(firestore, 'musicVideoSummaries'));
      const updatePromises = [];

      mvsSnap.forEach((docSnap) => {
        const d = docSnap.data();
        const videos = Array.isArray(d.videos) ? d.videos : [];
        const filteredVideos = videos.filter(
          (v) => (v.contentId ?? v.id) !== contentId
        );

        if (filteredVideos.length !== videos.length) {
          const ref = doc(firestore, 'musicVideoSummaries', docSnap.id);
          updatePromises.push(updateDoc(ref, { videos: filteredVideos }));
        }
      });

      if (updatePromises.length) {
        await Promise.all(updatePromises);
      }

      // update local videos state
      if (typeof setMusicVideos === 'function') {
        setMusicVideos((prev) =>
          Array.isArray(prev)
            ? prev.filter((v) => (v.contentId ?? v.id) !== contentId)
            : prev
        );
      }

      alert('Success', `Removed video "${contentId}".`);
      return;
    }

    // MUSIC (non-video) path: unchanged
    const summaryId = 'summary_1';
    const summaryRef = doc(firestore, 'musicSummaries', summaryId);

    await runTransaction(firestore, async (transaction) => {
      const summarySnap = await transaction.get(summaryRef);
      if (!summarySnap.exists()) {
        throw new Error(`"${summaryId}" does not exist in musicSummaries.`);
      }

      const data = summarySnap.data();
      const posts = Array.isArray(data.posts) ? data.posts : [];
      const filteredPosts = posts.filter(
        (post) => (post.id ?? post.contentId) !== contentId
      );

      if (filteredPosts.length !== posts.length) {
        transaction.update(summaryRef, { posts: filteredPosts });
      }
    });

    if (allSingles.some((i) => i.contentId === contentId)) {
      setAllSingles((prev) => prev.filter((i) => i.contentId !== contentId));
    } else if (allAlbums.some((i) => i.contentId === contentId)) {
      setAllAlbums((prev) => prev.filter((i) => i.contentId !== contentId));
    }

    alert('Success', `Removed entry with contentId "${contentId}" from "summary_1".`);
  } catch (error) {
    console.error('Error removing entry:', error);
    alert('Error', error.message || 'An error occurred while updating.');
  } finally {
    setLoading(false);
  }
};

const [myPosts, setMyPosts] = useState([]);

const [profiles, setProfiles] = useState([]);

const [hasUnread, setHasUnread] = useState(false);

const [currentView, setCurrentView] = useState('profiles');

const [profileViewing, setProfileViewing] = useState(null);



useEffect(() => {
  
  const unsubscribeAuth = auth.onAuthStateChanged(user => {
    if (user) {
      setIsLoggedIn(true);
      

      const statesAbbreviations = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

      const analyticsCategories = [
        { key: 'Album', viewing: viewingAlbumAnalytics },
        { key: 'Single', viewing: viewingSingleAnalytics },
        { key: 'Videos', viewing: viewingVideosAnalytics },
        { key: 'Verch', viewing: viewingVerchAnalytics },
        { key: 'TotalSpns', viewing: viewingTotalSpnsAnalytics, dbKey: 'RecentSpns' }
      ];

      analyticsCategories.forEach(category => {
        
        if (category.viewing) {
          // Setup listeners for state-specific counts
          statesAbbreviations.forEach(state => {
            const stateRef = ref(database, `users/${user.uid}/stats/State${category.key}Locations/${state}`);
            
            stateListeners.current[`${category.key}_${state}`] = onValue(stateRef, snapshot => {
              if (snapshot.exists()) {
                
                setStateCountsSKN(prev => ({
                  ...prev,
                  [`${category.key}_${state}`]: snapshot.val()
                }));
              } else {
                
                setStateCountsSKN(prev => {
                  const newStateCounts = { ...prev };
                  delete newStateCounts[`${category.key}_${state}`];
                  return newStateCounts;
                });
              }
            });
          });

          // Setup listeners for recent activities
          const dbKey = category.dbKey || `Recent${category.key}`;
          const recentRef = ref(database, `users/${user.uid}/stats/${dbKey}`);
          
          stateListeners.current[dbKey] = onValue(recentRef, snapshot => {
            if (snapshot.exists()) {
              
              setRecentData(prev => ({
                ...prev,
                [dbKey]: snapshot.val()
              }));
            } else {
              
              setRecentData(prev => {
                const newRecentData = { ...prev };
                delete newRecentData[dbKey];
                return newRecentData;
              });
            }
          });
        } else {
          // Cleanup listeners for both state-specific counts and recent activities
          statesAbbreviations.forEach(state => {
            const listenerKey = `${category.key}_${state}`;
            if (stateListeners.current[listenerKey]) {
              
              stateListeners.current[listenerKey]();
              delete stateListeners.current[listenerKey];
            }
          });
          const dbKey = category.dbKey || `Recent${category.key}`;
          if (stateListeners.current[dbKey]) {
            
            stateListeners.current[dbKey]();
            delete stateListeners.current[dbKey];
          }
        }
      });
    } else {
      setIsLoggedIn(false);
      
      // When the user logs out, unsubscribe from all listeners
      Object.values(stateListeners.current).forEach(unsubscribe => unsubscribe?.());

      // Reset the state to ensure no stale data remains
      setStateCountsSKN({});
      setRecentData({});
    }
  });

  // Cleanup function to unsubscribe from all listeners upon component unmount or auth state change
  return () => {
    
    unsubscribeAuth(); // Unsubscribe from auth state changes
    // Additionally, unsubscribe from all dynamically created listeners
    Object.values(stateListeners.current).forEach(unsubscribe => unsubscribe?.());
    // Reset the reference object for state listeners to prevent memory leaks
    stateListeners.current = {};
  };
}, [
  viewingAlbumAnalytics,
  viewingSingleAnalytics,
  viewingVideosAnalytics,
  viewingVerchAnalytics,
  viewingTotalSpnsAnalytics,
  auth, // Make sure to include `auth` if it's a dependency that could change
]);


useEffect(() => {

  let unsubscribeConversations = () => {};

  const ensureSummaryDocumentExists = async (userId) => {
    const summaryRef = doc(firestore, 'users', userId, 'conversationsSummary', 'summary');
    const summarySnap = await getDoc(summaryRef);

    if (!summarySnap.exists()) {
      await setDoc(summaryRef, { conversations: {} });
    }
  };

  const subscribeToConversations = (userId) => {
    const summaryRef = doc(firestore, 'users', userId, 'conversationsSummary', 'summary');
    unsubscribeConversations = onSnapshot(summaryRef, docSnapshot => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.conversations) {
          const profiles = Object.keys(data.conversations).map(conversationId => {
            const conversation = data.conversations[conversationId];
            const lastMessageTimestamp = conversation.latestMessageTimestamp ? conversation.latestMessageTimestamp.toDate() : null;

            return {
              id: conversationId,
              otherUserId: conversation.otherUser.userId,
              unread: conversation.unread,
              lastMessageTimestamp: lastMessageTimestamp,
              ...conversation.otherUser  // Include user data for display
            };
          });

          // Sort profiles by lastMessageTimestamp in descending order
          profiles.sort((a, b) => b.lastMessageTimestamp - a.lastMessageTimestamp);

          setProfiles(profiles);
        } else {
          setProfiles([]);
        }
      } else {
        setProfiles([]);
      }
    }, (error) => {
      console.error('Error fetching conversation summaries:', error);
    });
  };

  if (userId2 && userId2 !== "guest") {
    ensureSummaryDocumentExists(userId2)
      .then(() => {
        subscribeToConversations(userId2);
      })
      .catch(error => {
        console.error('Error ensuring summary document exists:', error);
      });
  } else {
    // Skip if userId2 is missing or guest
  }

  return () => {
    unsubscribeConversations();
  };
}, [userId2]);


useEffect(() => {
  const anyUnread = profiles.some(profile => profile.unread);
  setHasUnread(anyUnread);
}, [profiles]);


  const [mediaData, setMediaData] = useState({
      singles: [],
      albums: [],
  });

const mandatoryFollowingIds = [
  "h0fEIStkM4XHTDErZM5i8XIo9rA3",
  "OHaY20b54nTGd5BBgbJOL2BHEbX2",
  "rdX289s3YBP31Hw5qn2eXVywtBq1",
  "Mkf4631LCEOYmHXWRzGirPdxBrt1"
];



useEffect(() => {
  const auth = getAuth();
  let currentUserID = null; // Local variable to hold the current user ID

  const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user && currentUserID !== user.uid) {
      currentUserID = user.uid;
      setUserId2(user.uid); // Set authenticated user ID
    } else if (!user && currentUserID !== "guest") {
      currentUserID = "guest"; // Set to "guest" for unauthenticated users
      setUserId2("guest");
    }
  });

  return () => unsubscribe();
}, []);






const [purchasedMovies, setPurchasedMovies] = useState([]);


const [userWallet, setUserWallet] = useState(null);

const [myDATS, setMyDATS] = useState([]); 
const [assets, setAssets] = useState([]);

const [userAssets, setUserAssets] = useState(null);

const [authUser, setAuthUser] = useState(null);



useEffect(() => {
  const auth = getAuth();
  const unsubscribeAuth = onAuthStateChanged(auth, (u) => {
    setTimeout(() => {
      // If you keep a local auth user, store it; otherwise you can inline `u` in the next effect.
      // If you don't have `setAuthUser` already, add this state above: const [authUser, setAuthUser] = useState(null);
      setAuthUser(u || null);
    }, 0);
  });

  return () => {
    unsubscribeAuth();
  };
}, []);

useEffect(() => {
  const firestore = getFirestore();

  let unsubscribeDoc = null;
  let unsubscribePurchasedMovies = null;
  let unsubscribeWallet = null;

  const teardown = () => {
    if (unsubscribeDoc) unsubscribeDoc();
    if (unsubscribePurchasedMovies) unsubscribePurchasedMovies();
    if (unsubscribeWallet) unsubscribeWallet();
    unsubscribeDoc = null;
    unsubscribePurchasedMovies = null;
    unsubscribeWallet = null;
  };

  // Guard: only attach listeners when we have a real, logged-in user
  // and your app-level `userId2` isn’t "guest".
  if (!authUser || !authUser.uid || !userId2 || userId2 === 'guest') {
    teardown();
    return () => teardown();
  }

  const userDocRef = doc(firestore, 'users', authUser.uid);

  // --- User document listener ---
  unsubscribeDoc = onSnapshot(
    userDocRef,
    (docSnapshot) => {
      if (docSnapshot.exists()) {
        const userData = docSnapshot.data();

        // User object
        setUser(userData);

        // Cleanse playlists and merge with purchasedMedia
        const cleansedPlaylists =
          (userData?.playlists || []).map((playlist) => ({
            ...playlist,
            id: cleanseId(playlist.id),
            contentId: cleanseId(playlist.contentId),
          })) || [];

        const updatedPurchasedMedia = [
          ...(userData.purchasedMedia || []),
          ...cleansedPlaylists,
        ];

        // Individual state values
        setVoiceDropMuted(Boolean(userData.voiceDropMuted));
        setFollowers(userData.followers || []);

        // Combine mandatory following IDs with user.following and user’s own id
        const updatedFollowing = new Set([
          ...mandatoryFollowingIds,
          authUser.uid,
          ...(userData.following || []),
        ]);
        setFollowing(Array.from(updatedFollowing));

        setNumberOfFollowers((userData.followers || []).length);
        setNumberOfFollowing(Array.from(updatedFollowing).length);

        setPlaylistsFresh(userData.playlists || []);
        setPurchasedMedia(updatedPurchasedMedia);
        setHasUnreadNotifications(Boolean(userData.hasUnreadNotifications));
        setBio(userData?.bio || '');
        setBlurb(userData?.blurb || '');
        setScreenSKNs([
          {
            buttonImage: require('./assets/images/screenSKN/screenSKNbuttonSPNDAT.png'),
            screenSKNName: 'Default',
            artistName: 'SPNDAT',
            isLocal: true,
          },
          ...(userData.ScreenSKNpurchased || []),
          ...(userData.ScreenSKN || []),
        ]);
        setProfileImageUrl(userData.profileImageUrl || '');
      } else {
        console.log('No such document!');
      }
    },
    (error) => {
      console.error('Error listening to user document:', error);
    }
  );

  // --- Wallet document listener ---
  const walletDocRef = doc(firestore, 'users', authUser.uid, 'wallet', 'main');
  unsubscribeWallet = onSnapshot(
    walletDocRef,
    (walletDocSnapshot) => {
      if (walletDocSnapshot.exists()) {
        const walletData = walletDocSnapshot.data();
        setUserWallet(walletData || { balance: 0, ownedDats: [] });
      } else {
        // Ensure a sane null/empty default (choose one pattern and keep it consistent)
        setUserWallet({ balance: 0, ownedDats: [] });
      }
    },
    (error) => {
      console.error('Error listening to wallet document:', error);
    }
  );

  // --- PurchasedMovies subcollection listener ---
  const purchasedMoviesRef = collection(
    firestore,
    'users',
    authUser.uid,
    'PurchasedMovies'
  );
  unsubscribePurchasedMovies = onSnapshot(
    purchasedMoviesRef,
    (snapshot) => {
      const purchasedMovies = snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setPurchasedMovies(purchasedMovies);
    },
    (error) => {
      console.error('Error listening to PurchasedMovies collection:', error);
    }
  );

  // Cleanup whenever authUser/userId2 changes or component unmounts
  return () => {
    teardown();
  };
}, [authUser, userId2]);




const [loading, setLoading] = useState(false);



const removeDuplicates = (array) => {
  const seen = new Set();
  return array.filter(item => {
    const key = item.id ?? item.userId;   // fall back to userId if id is undefined
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};


useEffect(() => {
  const fetchSize = 8;

  const millis = ts =>
    !ts ? 0 :
    typeof ts === 'number' ? ts :
    typeof ts === 'string' ? new Date(ts).getTime() :
    ts?.toMillis ? ts.toMillis() : 0;

  const tsOrCreated = (item) =>
    millis(item?.releaseTimestamp) || millis(item?.createdAt);

  const norm = n => n?.trim().replace(/\s*ft\..*$/i, '').trim();

  const initLoad = async () => {
    setLoading(true);

    try {
      // Kick off all reads together
      const [
        assetsSnap,
        featuredMusicSnap,
        musicSummariesSnap,
        artistsSummarySnap,
        musicVideoSummariesSnap
      ] = await Promise.all([
        getDoc(doc(firestore, 'assetsSummary',        'main')),
        getDoc(doc(firestore, 'featuredMusicSummary', 'summary_1')),
        getDocs(collection(firestore, 'musicSummaries')),
        getDoc(doc(firestore, 'featuredArtistsSummary','summary_1')),
        getDocs(collection(firestore, 'musicVideoSummaries'))
      ]);

      /* ──────── 1. ASSET SUMMARY (NFTs etc.) ──────── */
      const assets = assetsSnap.exists() ? assetsSnap.data().assets || [] : [];
      setAssetsSummary(assets);   // must be first for downstream merges

      /* ──────── 2. MUSIC SUMMARIES → albums & singles ──────── */
      let allMusic = [];
      musicSummariesSnap.forEach(s => {
        const d = s.data();
        if (Array.isArray(d.posts)) allMusic.push(...d.posts);
      });
      allMusic.sort((a, b) => millis(b.releaseTimestamp) - millis(a.releaseTimestamp));

      const albums  = allMusic.filter(i =>  i.isAlbum);
      const singles = allMusic.filter(i => !i.isAlbum);

      setAllAlbums(albums);
      setAllSingles(singles);

      const buckets = {};
      [...albums, ...singles].forEach(i => {
        const g = Array.isArray(i.genres) ? i.genres[0] : i.genre;
        (buckets[g] ||= []).push(i);
      });
      setGroupedByGenresMusic(buckets);

      setFeaturedSongs(prev => removeDuplicates([...albums .slice(0, fetchSize), ...(prev || [])]));
      setNewReleases (prev => removeDuplicates([...singles.slice(0, fetchSize), ...(prev || [])]));

      /* ──────── 2.5 MUSIC VIDEO SUMMARIES → musicVideos ──────── */
      let allVideos = [];
      musicVideoSummariesSnap.forEach(s => {
        const d = s.data();
        if (Array.isArray(d.videos)) allVideos.push(...d.videos);
      });
      allVideos.sort((a, b) => tsOrCreated(b) - tsOrCreated(a));
      setMusicVideos(allVideos);

      /* ──────── 3. FEATURED MUSIC summary → dataFeaturedMusic ──────── */
      const fm = featuredMusicSnap.exists() &&
                 Array.isArray(featuredMusicSnap.data().entries)
        ? featuredMusicSnap.data().entries
        : [];
      fm.sort((a, b) => millis(b.releaseTimestamp) - millis(a.releaseTimestamp));
      const freshFM = fm.slice(0, 50);

      const assetMap   = new Map(assets.map(a => [norm(a.SongName), a]));
      const fallback   = new Map([...singles, ...albums].map(i => [i.contentId, i]));

      const replace = arr => arr.map(item =>
        assetMap.get(norm(item.SongName)) ||
        fallback.get(item.contentId)      ||
        item
      );

      setDataFeaturedMusic(prev => {
        const prevSafe  = prev || [];
        const keysFresh = new Set(freshFM.map(i => norm(i.SongName)));
        const carry     = prevSafe.filter(p => !keysFresh.has(norm(p.SongName)));
        return [...replace(freshFM), ...replace(carry)];
      });

      /* ──────── 4. FEATURED ARTISTS summary → producers / artists ──────── */
      const artistsArr = artistsSummarySnap.exists() &&
                         Array.isArray(artistsSummarySnap.data().artists)
        ? artistsSummarySnap.data().artists
        : [];

      const newProducers = artistsArr
        .filter(a => a.accountType === 'Producer')
        .slice(0, fetchSize);

      const newFeatArts = artistsArr
        .filter(a => a.accountType !== 'Producer')
        .slice(0, fetchSize);

      setProducers(prev       => removeDuplicates([...newProducers, ...(prev || [])]));
      setFeaturedArtists(prev => removeDuplicates([...newFeatArts,  ...(prev || [])]));

    } catch (err) {
      console.error('Initial payload error:', err);
    } finally {
      setLoading(false);
    }
  };

  initLoad();
}, []);



useEffect(() => {
  if (userWallet && assetsSummary) {

    
    const userOwnedEditions = (userWallet.ownedDats || []).filter(
      (ownedDat) => typeof ownedDat.edition === 'number' && ownedDat.edition >= 1 && ownedDat.edition <= 20
    ); // Filter to only include editions between 1 and 20

    const userAssets = assetsSummary?.map((asset) => {
      const ownedEditions = userOwnedEditions
        .filter((ownedDat) => ownedDat.id === asset.id)
        .map((ownedDat) => {
          const editionDetails = asset.editions.find(
            (edition) => edition.edition === ownedDat.edition
          );
          return { ...editionDetails, id: asset.id, ...asset };
        });

      return ownedEditions.length ? { ...asset, ownedEditions } : null;
    }).filter(Boolean);

    if (userAssets?.length > 0) {
      userAssets.forEach((asset, index) => {
      });
    } else {

    }



    setUserAssets(userAssets);

    // Filter assets where creatorId matches "userId2" and set them in myDATS state
    const myDATS = assetsSummary?.filter(asset => asset.creatorId === userId2) || [];
    
    if (myDATS.length > 0) {

    } else {

    }

    setMyDATS(myDATS); 
  }
}, [userWallet, assetsSummary]);


  const [imageUri, setImageUri] = useState(null);
  const [tempImageUri, setTempImageUri] = useState(null);


  //livestreamstuffstartshere

  const [viewingProfile, setViewingProfile] = useState(null);



  const [callIdView, setCallIdView] = useState(null);
  const [clientView, setClientView] = useState(null);
  const [isChatHidden, setIsChatHidden] = useState(false);
  const [hideViewers, setHideViewers] = useState(true);
  const [isLivestreamEnded, setIsLivestreamEnded] = useState(false);
  const [isViewingLivestream, setIsViewingLivestream] = useState(false);
  
  const [participants, setParticipants] = useState([]);
  
  const onLeave = async () => {
  
  

      setIsViewingLivestream(false);
      setCallIdView(null);
      setClientView(null);
  };
  
  useEffect(() => { 
    if (isLivestreamEnded) {
      onLeave();
      setIsLivestreamEnded(false);
    }
  }, [isLivestreamEnded]);
  
  
  const handleHideChat = () => {

    if (!isChatHidden) {
    setIsChatHidden(true);
    } else {
    setIsChatHidden(false);
    }
  };
  
  const handleHideViewers = () => {

    if (!hideViewers) {
    setHideViewers(true);
    } else {
    setHideViewers(false);
    }
  };
  
  const [isLive, setIsLive] = useState(false);
  const [token, setToken] = useState(null);
  const [tokenView, setTokenView] = useState(null);
  const [callId, setCallId] = useState(null); 
  const [client, setClient] = useState(null);
  const [call, setCall] = useState(null);
  const apiKey = '66nb2pewaf5d';
  const clientSecret = 'hvdpaq2yjvkae8fny5yz7wtnwhtv6jemymusnd76vxnvzuverny2xg6kywwv3xqz';
  const generateToken = async () => {
    try {

        const functions = getFunctions();
        const generateStreamToken = httpsCallable(functions, 'generateStreamToken');
        const response = await generateStreamToken();
        return response.data.token;
    } catch (error) {

        throw error;
    }
  };
  
  const generateTokenView = async () => {
    try {

        const functions = getFunctions();
        const generateStreamTokenView = httpsCallable(functions, 'generateStreamTokenView');
        const response = await generateStreamTokenView();

        return response.data.token;
    } catch (error) {
        console.error('Error generating token:', error);
        throw error;
    }
  };
  
  const generateRandomString = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      const randomChar = characters.charAt(Math.floor(Math.random() * charactersLength));
      result += randomChar;

    }

    return result;
  };
  
  useEffect(() => {
    if (callId) {

    }
  }, [callId]);
  
useEffect(() => {
  if (userId2 && userId2 !== "guest" && (!token || !tokenView)) {
    const getToken = async () => {
      try {
        const fetchedToken = await generateToken();
        setToken(fetchedToken);

        if (!tokenView) {
          const fetchedTokenView = await generateTokenView();
          setTokenView(fetchedTokenView);
        }
        if (!callId) {
          setCallId(generateRandomString(12));
        }
      } catch (error) {

      }
    };
    getToken();
  }
}, [currentUser]);

  
  
  
  
  useEffect(() => {
    if (isLive) {
      const userStatusDatabaseRef = databaseRef(database, `/status/${userId2}`);
      const isOfflineForDatabase = {
        state: 'offline',
        callId: callId,
        last_changed: new Date().toISOString(),
      };
      const isOnlineForDatabase = {
        state: 'online',
        callId: callId,
        last_changed: new Date().toISOString(),
      };
  
      onDisconnect(userStatusDatabaseRef).set(isOfflineForDatabase).then(() => {
        set(userStatusDatabaseRef, isOnlineForDatabase);
      });
  
      return () => {
        set(userStatusDatabaseRef, isOfflineForDatabase);
      };
    }
  }, [isLive]);
  
  
  const startLivestream = async () => {
    try {

  
      if (token && !client) {

        const user: User = { id: userId2, name: 'LIVESTREAM' };

  
        const videoClient = new StreamVideoClient({ apiKey, user, token });
        setClient(videoClient);

  
        const callInstance = videoClient.call('livestream', callId);
        await callInstance.join({ create: true });

        setCall(callInstance);
  
        callInstance.camera.enable();
        callInstance.microphone.enable();
  

        await callInstance.create();

        await callInstance.goLive();

  
        const userDocRef = doc(firestore, 'users', userId2);
        await updateDoc(userDocRef, {
          callId: callId,
          isLive: true,
        });

  
        const livestreamDocRef = databaseRef(database, `livestreams/${callId}`);
        const livestreamDoc = await get(livestreamDocRef);

  
        if (!livestreamDoc.exists()) {

          await set(livestreamDocRef, {
            currentMessageDocId: `${callId || userId2}-1`,
            messageDocs: [],
            status: 'live',
            host: currentUser?.userId,
          });

        }
  setIsLive(true);

      }
    } catch (error) {
      console.error('Error initializing StreamVideoClient:', error);
    }
  };
  
  
  
  
  const stopLivestream = async () => {
    if (call) {
      try {
        setClient(null);
        setCall(null);
        setIsLive(false); // Set isLive to false to trigger cleanup in useEffect
        const userDocRef = doc(firestore, 'users', userId2);
        await updateDoc(userDocRef, {
          callId: '',
          isLive: false,
        });
        const livestreamDocRef = databaseRef(database, `livestreams/${callId}`);
        await update(livestreamDocRef, {
          status: 'ended'
        });
        const fetchedToken = await generateToken();
        setToken(fetchedToken);

        if (!tokenView) {
        const fetchedTokenView = await generateTokenView();
        setTokenView(fetchedTokenView);
        }
        setLivestreamingVisible(false);
        setCallId(generateRandomString(12));

      } catch (error) {
        console.error('Error stopping livestream:', error);
      }
    }
  };
  
  const [streamPrompt, setStreamPrompt] = useState(false);
  const [joiningStream, setJoiningStream] = useState(false);
  
  const handleStreamPrompt = () => {
  console.log('Opening stream prompt...');
    setStreamPrompt(true);
  };
  
  const handleCloseStreamPrompt = () => {
  console.log('Closing stream prompt...');
    setStreamPrompt(false);
  };
  
const startViewingLivestream = async (profileArg) => {
  // Use the passed-in profile when provided; otherwise fall back to existing state
  const profile = profileArg ?? viewingProfile;

  try {
    setStreamPrompt(false);

    if (tokensUtility < 1) {
            alert("Add Utility Tokens to join this livestream");
                  setJoiningStream(false);
    return;
  }

    setCurrentlyBuying(true);

    const functions = getFunctions();
    const joinLiveStream = httpsCallable(functions, 'joinLiveStream2');

    const now = new Date();
    const readableTimestamp = now.toLocaleString('en-US', {
      hour12: true,
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

    if (!profile?.userId) {
      throw new Error('Missing userId for livestream.');
    }

    // Keep global state aligned with what we’re using to join
    setViewingProfile(profile);

    // Charge / join intent on server
    const result = await joinLiveStream({ userId: profile.userId, readableTimestamp });

    if (result?.data?.status !== 'success') {
      const errorMessage = result?.data?.message || 'Failed to join livestream';
      console.error('Join livestream failed:', errorMessage);
      setJoiningStream(false);
      throw new Error(errorMessage);
    }

    if (tokenView && profile?.callId) {
      const user = { id: '!anon', type: 'anonymous' };
      const videoClient = new StreamVideoClient({ apiKey, user, tokenView });

      setClientView(videoClient);
      setCallIdView(profile.callId);

      const callInstance = videoClient.call('livestream', profile.callId);

      try {
        const functions = getFunctions();
        const spendFn = httpsCallable(functions, 'joinLivestreamSpendOneToken');
        spendFn({ streamerId: profile.userId, callId: profile.callId }).catch(() => {});
      } catch (e) {
        console.warn('joinLivestreamSpendOneToken fire-and-forget failed to start:', e?.message || e);
      }

      await callInstance.join();

      setJoiningStream(false);
      setIsViewingLivestream(true);
      setCurrentlyBuying(false);
    } else {
      console.warn('Token or callId missing - Token:', tokenView, 'CallId:', profile?.callId);
      setJoiningStream(false);
      setCurrentlyBuying(false);
    }
  } catch (error) {
    console.error('Error initializing StreamVideoClient for viewing:', error);
    setCurrentlyBuying(false);
    setJoiningStream(false);
    alert('Failed to join livestream: ' + error.message);
  } finally {
    setCurrentlyBuying(false);
          setJoiningLive(false);
  }
};

  
  
  const [userIsLive, setUserIsLive] = useState(false);
  const [livestreamingVisible, setLivestreamingVisible] = useState(false);

  const statusListenerRef = useRef(null);


  const libraryFetched = useRef(false);

  const [library, setLibrary] = useState([]);

  const libraryUnsubRef = useRef(null);

useEffect(() => {
  const auth = getAuth(); 
  const db = getFirestore();

  // Fires every time Firebase changes auth state.
  const unsubscribeAuth = onAuthStateChanged(auth, user => {
    // 1️⃣  Stop any listener that might still be running.
    if (libraryUnsubRef.current) {
      libraryUnsubRef.current();
      libraryUnsubRef.current = null;
    }

    // 2️⃣  Signed out → clear state and we're done.
    if (!user) {
      setLibrary([]);
      return;
    }

    // ✅ Only proceed if userId2 exists and is not "guest"
    if (userId2 && userId2 !== "guest") {
      // 3️⃣  Signed in → attach a fresh listener for this user.
      const libRef = doc(db, 'users', user.uid, 'library', 'myLibrary');

      libraryUnsubRef.current = onSnapshot(
        libRef,
        snap => {
          if (!snap.exists()) {
            setLibrary([]);
            return;
          }

          const rawAssets = snap.data().assets || [];

          // Deduplicate by contentId, always preferring an entry that has isNFT.
          const seen = new Map();
          for (const asset of rawAssets) {
            const id = asset?.contentId;
            if (!id) continue;

            const incomingHasNFT = Object.prototype.hasOwnProperty.call(asset, 'isNFT');
            const existing = seen.get(id);
            const existingHasNFT = existing && Object.prototype.hasOwnProperty.call(existing, 'isNFT');

            if (!existing || (incomingHasNFT && !existingHasNFT)) {
              seen.set(id, asset);
            }
          }

          setLibrary(Array.from(seen.values()));
        },
        err => {
          // When the user signs out, Firestore will emit exactly one
          // “permission-denied”; ignore that but still clear the UI.
          if (err.code !== 'permission-denied') {
            console.error('⚠️ Library listener error:', err);
          }
          setLibrary([]);
        }
      );
    } else {
      // Skip subscribing if userId2 is missing or guest
      setLibrary([]);
    }
  });

  // 4️⃣  Global cleanup when the component unmounts.
  return () => {
    unsubscribeAuth();
    if (libraryUnsubRef.current) libraryUnsubRef.current();
  };
}, []);




  const myLastSummaryDocRef = useRef({ index: null });
const myPendingBufferRef  = useRef([]);
const myPendingIdsRef     = useRef(new Set());
const myReachedEndRef     = useRef(false);

const [newProfileImageCache, setNewProfileImageCache] = useState({});

const [userPosts, setUserPosts] = useState([]);

const [allPosts, setAllPosts] = useState([]);

const [earningsCache, setEarningsCache] = useState({});

const [groupedByGenresMusic, setGroupedByGenresMusic] = useState({});
  const [allAlbums,  setAllAlbums]  = useState([]);
  const [allSingles, setAllSingles] = useState([]);
  const [producers, setProducers] = useState([]);
const [featuredArtists, setFeaturedArtists] = useState([]);


const handleLibraryAdd = async (item) => {
  setCurrentlyBuying(true);
  setIsPurchasing(true);

  const buyer     = userId2;            // current user
  const seller    = item.userId;        // asset owner
  const datId     = item.contentId;     // asset ID
  const timestamp = Date.now();

  try {
    const functions = getFunctions();
    const transactionProcessorLibrary =
      httpsCallable(functions, 'transactionProcessorLibraryDatChain');

    const { data } = await transactionProcessorLibrary({
      buyer,
      seller,
      datId,
      timestamp,
    });

    if (data.success) {
      // credits-only path: asset is already purchased
    } else if (data.url) {
      // Stripe payment required: open the dynamic link in a new tab
      window.open(data.url, '_blank', 'noopener,noreferrer');
    } else {
      console.warn('[handleLibraryAdd] Unexpected response:', data);
      alert('Error', 'The purchase did not go through.');
    }
  } catch (error) {
    console.error('[handleLibraryAdd] Error calling transactionProcessorLibrary:', error);
    alert('Error', 'Something went wrong. Please try again.');
  } finally {
    setCurrentlyBuying(false);
    setIsPurchasing(false);
  }
};

const handleLibraryAddSong = async (item) => {
  setCurrentlyBuying(true);

  const buyer     = userId2;            // current user
  const seller    = item.userId;        // asset owner
  const datId     = item.contentId;     // asset ID
  const timestamp = Date.now();

  try {
    const functions = getFunctions();
    const addReleaseToLibrary =
      httpsCallable(functions, 'addReleaseToLibraryDatChain2');

    const { data } = await addReleaseToLibrary({
      buyer,
      seller,
      datId,
      timestamp,
    });

    if (data.success) {
      // credits-only path: asset is already purchased
    } else if (data.url) {
      // Stripe payment required: open the dynamic link in a new tab
      window.open(data.url, '_blank', 'noopener,noreferrer');
    } else {
      console.warn('[handleLibraryAddSong] Unexpected response:', data);
      alert('Error', 'The purchase did not go through.');
    }
  } catch (error) {
    console.error('[handleLibraryAddSong] Error calling addReleaseToLibrary:', error);
    alert('Error', 'Something went wrong. Please try again.');
  } finally {
    setCurrentlyBuying(false);
  }
};


async function playNextSong() {
  if (currentPlaylist.length === 0) return;

  let nextIndex = currentIndex + 1;
  if (nextIndex >= currentPlaylist.length) nextIndex = 0;

  const nextSong = currentPlaylist[nextIndex];
  setCurrentIndex(nextIndex);
  playSong(nextSong.SongURL);
  setMiniPlayer(nextSong);

// 1. Utility to strip trailing “-123” or “_123”
const sanitizeId = id => id.replace(/[-_]\d+$/, '');

// 2. Test for “purely numeric” IDs
const isPureNumber = id => /^[0-9]+$/.test(id);

// 3. Before you do any .some() tests, grab the base ID for the next song:
const baseNextId = sanitizeId(nextSong.contentId);

// 4. Now your checks become:
const inLibrary = library.some(({ contentId }) => {
  const base = sanitizeId(contentId);
  return base === baseNextId || isPureNumber(base);
});

const inPurchased = currentUser?.purchasedMedia?.some(({ contentId }) => {
  const base = sanitizeId(contentId);
  return base === baseNextId || isPureNumber(base);
});


  if (!inLibrary && !inPurchased) {
    const streamFn = httpsCallable(
      getFunctions(),
      'streamSummaryContentIOSEditionDatChain'
    );
    try {
      await streamFn({
        contentId:     nextSong.contentId,
        creatorId:     nextSong.userId,
        isVideo:       nextSong.isVideo,
        streamSongName: nextSong.SongName || nextSong.albumName,
        readableTimestamp: new Date().toISOString(),
        timestamp:         Date.now(),
      });
    } catch (err) {
      console.error('Failed to log stream:', err);
    }
  }
}

async function playPreviousSong() {
  if (currentPlaylist.length === 0) return;

  let prevIndex = currentIndex - 1;
  if (prevIndex < 0) prevIndex = currentPlaylist.length - 1;

  const prevSong = currentPlaylist[prevIndex];
  setCurrentIndex(prevIndex);
  playSong(prevSong.SongURL);
  setMiniPlayer(prevSong);

// 1. Utility to strip trailing “-123” or “_123”
const sanitizeId = id => id.replace(/[-_]\d+$/, '');

// 2. Test for “purely numeric” IDs
const isPureNumber = id => /^[0-9]+$/.test(id);

// 3. Before you do any .some() tests, grab the base ID for the next song:
const baseNextId = sanitizeId(prevSong.contentId);

// 4. Now your checks become:
const inLibrary = library.some(({ contentId }) => {
  const base = sanitizeId(contentId);
  return base === baseNextId || isPureNumber(base);
});

const inPurchased = currentUser?.purchasedMedia?.some(({ contentId }) => {
  const base = sanitizeId(contentId);
  return base === baseNextId || isPureNumber(base);
});


  if (!inLibrary && !inPurchased) {
    const streamFn = httpsCallable(
      getFunctions(),
      'streamSummaryContentIOSEditionDatChain'
    );
    try {
      await streamFn({
        contentId:     prevSong.contentId,
        creatorId:     prevSong.userId,
        isVideo:       prevSong.isVideo,
        streamSongName: prevSong.SongName || prevSong.albumName,
        readableTimestamp: new Date().toISOString(),
        timestamp:         Date.now(),
      });
    } catch (err) {
      console.error('Failed to log stream:', err);
    }
  }
}


const [isPurchasing, setIsPurchasing] = useState(false);




    const [datWallet, setDatWallet]   = useState([]);

    const [totalDatTokens, setTotalDatTokens] = useState("ADD");

    const [tokensUtility, setTokensUtility] = useState(0);


        const [owned, setOwned]   = useState(0);

useEffect(() => {
  const db = getDatabase();
  const auth = getAuth();

  let walletRef = null;
  let walletUnsub = null;

  const stopWallet = () => {
    if (walletRef && walletUnsub) {
      off(walletRef, 'value', walletUnsub);
      walletRef = null;
      walletUnsub = null;
    }
  };

  const numFromAny = (n) => {
    if (n == null) return 0;
    if (typeof n === 'number') return Number.isFinite(n) ? n : 0;
    if (typeof n === 'string') return Number(n) || 0;
    if (typeof n === 'object') return numFromAny(Object.values(n)[0]);
    return 0;
  };

  const unifyRewards = (v) =>
    // unified rewards (regular + legacy buckets)
    numFromAny(v?.rewards) +
    numFromAny(v?.rebate) +
    numFromAny(v?.internalRebate) +
    numFromAny(v?.internalRewards) +
    numFromAny(v?.rewardsTokens) +
    numFromAny(v?.rebates);

  const authUnsub = onAuthStateChanged(auth, (user) => {

    stopWallet();

    if (!user) {
      setOwned(0);
      setDatWallet({});
        setTokensUtility(0);
setTotalDatTokens("ADD");

      return;
    }

    walletRef = ref(db, `datchainwallets/${user.uid}`);

    walletUnsub = onValue(
      walletRef,
      (snap) => {

        if (!snap.exists()) {
          console.log('snapshot empty');
          setOwned(0);
          setTotalDatTokens("ADD");
            setTokensUtility(0);
          setDatWallet({});
          console.groupEnd();
          return;
        }

        const raw = snap.val();


        // normalize → { price, qty, rewards }
        const cleaned = Object.fromEntries(
          Object.entries(raw).map(([bid, v]) => {
            const price   = numFromAny(v?.price);
            const qty     = numFromAny(v?.qty);
            const rewards = unifyRewards(v);
            return [bid, { price, qty, rewards }];
          })
        );

        setDatWallet(cleaned);

        

const totalQty = Object.values(cleaned).reduce((s, e) => s + (e.qty || 0), 0);

setOwned(totalQty);

const totalTokens = Object.values(cleaned).reduce(
  (s, e) => s + (e.qty || 0) + (e.rewards || 0),
  0
);

const totalDisplay = totalTokens === 0 ? "ADD" : totalTokens;

setTotalDatTokens(totalDisplay);

const utilityUsd = Object.values(cleaned).reduce((sum, e) => {
  const qty = Number(e?.qty || 0);
  const rew = Number(e?.rewards || 0);
  const price = Number(e?.price || 0);
  return sum + (qty + rew) * price;
}, 0);

setTokensUtility(utilityUsd);

        console.groupEnd();
      },
      (err) => console.error('💥 wallet listener error', err)
    );

    get(walletRef)
      .then((s) => console.log('wallet exists', s.exists()))
      .catch((e) => console.error('💥 wallet get() error', e));
  });

  return () => {
    authUnsub();
    stopWallet();
  };
}, [setOwned, setDatWallet, setTotalDatTokens, setTokensUtility]);



const videoCountCacheRef = useRef(new Map());
const [viewedVideos, setViewedVideos] = useState(new Set());

const addViewedVideo = async (id) => {
  if (!id) return;

  // Local per-session guard so we only call once per session
  setViewedVideos(prev => {
    const next = new Set(prev);
    next.add(id);
    return next;
  });

  try {
    const auth = getAuth();
    if (!auth.currentUser) {
      // If you support anonymous, you can signInAnonymously() before calling.
      return;
    }
    const functions = getFunctions(); // optionally: getFunctions(undefined, 'your-region')
    const incrementView = httpsCallable(functions, 'incrementVideoView');
    await incrementView({ videoId: id });
  } catch (e) {
    console.warn('incrementVideoView failed:', e?.message || e);
  }
};


  return (
    <AppContext.Provider value={{ 
      dataFeaturedMusic, setDataFeaturedMusic,
      featuredSongs, setFeaturedSongs,
      newReleases, setNewReleases,
      newVideoReleases,
      setNewVideoReleases,
      dataFeaturedVideos,
      setDataFeaturedVideos,
      groupedByGenres,
      setGroupedByGenres,
      lastGenreDocs,
      setLastGenreDocs,
      tempImageUri, setTempImageUri, imageUri, setImageUri, profileViewing, setProfileViewing,
      currentlyReleasing, setCurrentlyReleasing,
      is480, isUnder390, isUnder480, showNewMessageScreen, setShowNewMessageScreen,
      voiceDropMuted, setVoiceDropMuted, isViewingScreenSKN, setIsViewingScreenSKN, isUnder400, isBetween400And479,
      currentlyBuying, setCurrentlyBuying, showSuccessAlertSKN, setShowSuccessAlertSKN,
      playNextSong,
      playPreviousSong,
      playPlaylistSequentially,
      playPlaylistShuffled,
      currentPlaylist,
      currentIndex,
      isShuffle,
      setIsShuffle,
      isPlaylist, setIsPlaylist,
      hasUnreadNotifications,
      screenSKNs, shareDATactive, setShareDATactive, showCreditSharePopup, setShowCreditSharePopup, currentlySharingCredits, setCurrentlySharingCredits, showSuccessAlertShareCredits, setShowSuccessAlertShareCredits, showCreditSharePopupProfile, setShowCreditSharePopupProfile, showShareDATPopupProfile, setShowShareDATPopupProfile, showShareDATPopup, setShowShareDATPopup, showSharePostPopup, setShowSharePostPopup, selectedUserIdShare, setSelectedUserIdShare, sharePostActive, setSharePostActive, postToShare, setPostToShare, stateCountsSKN, recentData, viewingTotalSpnsAnalytics, setViewingTotalSpnsAnalytics,
      viewingAlbumAnalytics, setViewingAlbumAnalytics,
      viewingSingleAnalytics, setViewingSingleAnalytics,
      viewingVideosAnalytics, setViewingVideosAnalytics,
      viewingVerchAnalytics, setViewingVerchAnalytics,
      viewingDefaultAnalytics, setViewingDefaultAnalytics,
      activeCategory, setActiveCategory, musicSpns, setMusicSpns, videoSpns, setVideoSpns,
      totalSpns, setTotalSpns, singlesSales, setSinglesSales, verchSales,
      albumsSales, setAlbumsSales, videosSales, setVideosSales, totalEarnings, currentEarnings,
      currentAnalyticsImage, setCurrentAnalyticsImage, viewingDefaultAnalyticsLocal, setViewingDefaultAnalyticsLocal, setBlurb, setBio, blurb, duration, setDuration, currentTime, setCurrentTime, toggleVideoPlayPause, isVideoPlaying, setIsVideoPlaying, miniPlayerVideo, setMiniPlayerVideo, handleCloseClick, videoRef, audioRef, setMiniPlayer, isPlaying, togglePlayPause, setPlaylistsFresh, playlistsFresh, miniPlayer, setMiniPlayer, playSong, selectedProfile, setSelectedProfile, currentView, setCurrentView, hasUnread, profiles, notifications, creditsIOS, userId2, profileImageUrl, myPosts, setMyPosts, bio, mediaData, followers, numberOfFollowers, numberOfFollowing, viewingTotalSpnsAnalytics, setViewingTotalSpnsAnalytics, viewingAlbumAnalytics, setViewingAlbumAnalytics, viewingSingleAnalytics, setViewingSingleAnalytics, viewingVideosAnalytics, setViewingVideosAnalytics, viewingVerchAnalytics, setViewingVerchAnalytics, 
      viewingDefaultAnalytics, setViewingDefaultAnalytics, viewingDefaultAnalyticsLocal, setViewingDefaultAnalyticsLocal, activeCategory, setActiveCategory, currentAnalyticsImage, setCurrentAnalyticsImage, reposts, setReposts, likes, setLikes, following, purchasedMedia, posts, currentUser, setPosts, setUser, profileImage, setProfileImage, credits, setCredits, isLoggedIn, setIsLoggedIn, purchasedMovies,
      callId,
      client,
      clientView,
      call,
      setParticipants,
      isChatHidden,
      setIsChatHidden,
      hideViewers,
      setHideViewers,
      isLivestreamEnded,
      setIsLivestreamEnded,
      isViewingLivestream,
      setIsViewingLivestream,
      participants,
      setCallIdView,
      callIdView, 
      setCall,
      setClientView,
      startLivestream,
      stopLivestream, handleHideChat, handleHideViewers,
      livestreamingVisible, setLivestreamingVisible,
      startViewingLivestream, setViewingProfile, joiningStream,
      statusListenerRef, userIsLive, setUserIsLive, assetsSummary, setAssetsSummary,
      myLastSummaryDocRef, myPendingBufferRef, myPendingIdsRef, myReachedEndRef, assets, userAssets, userWallet,
      creditsRaw, library, setLibrary, newProfileImageCache, setNewProfileImageCache,
      userPosts, setUserPosts, allPosts, setAllPosts, setNotifications, creditsCur,
      earningsCache, setEarningsCache,
      groupedByGenresMusic, setGroupedByGenresMusic,
      allSingles, setAllSingles, allAlbums, setAllAlbums,
      featuredArtists, setFeaturedArtists,
      producers, setProducers, handleLibraryAdd, handleLibraryAddSong,
      setUserWallet, setCurrentUser, isPurchasing, setIsPurchasing,
      creditsEarned, setMediaData, removeContent,
      datWallet, totalDatTokens,   tokensUtility,
      joiningLive, setJoiningLive,
      currentlyLoadingProfile, setCurrentlyLoadingProfile,
      musicVideos, setMusicVideos,
      viewedVideos, setViewedVideos, addViewedVideo,
videoCountCacheRef,
      }}>
      {children} 
    </AppContext.Provider>
  );
};
